<mat-divider></mat-divider>

<div style="padding: 10px; font-size: 14px; text-align: center">
  <div class="info">
    {{ 'activation.pin.info-one' | translate}}
  </div>
  <div class="info">
    {{ 'activation.pin.info-two' | translate}}
  </div>
  <div class="pin-text-container">
    <p>{{ 'activation.pin.pinTextForAllOs' | translate}}</p>
  </div>
  <div class="linux-text-container-puk" *ngIf="isOsLinux">
    <p>{{ 'activation.pin.pukTextForLinuxOne' | translate}}</p>
    <p>{{ 'activation.pin.pukTextForLinuxTwo' | translate}}</p>
  </div>
  <div class="non-linux-text-container-puk" *ngIf="!isOsLinux">
    <p>{{ 'activation.pin.pukTextForOtherOs' | translate}}</p>
  </div>
</div>

<div class="warning">
  {{ 'activation.pin.warning' | translate}}
</div>

<div>
  <input class="pin-puk-info" [placeholder]="pinValue" disabled/> 
  <button class="button" (click)="changePin()">
    {{ 'activation.pin.changePin' | translate}}
  </button>
</div>

<div>
  <input class="pin-puk-info" [placeholder]="pukValue" disabled/>  
  <button class="button" (click)="changePuk()">
    {{ 'activation.pin.changePuk' | translate}}
  </button>
</div>

<!-- TODO ngIf = pin/puk changed -->
<div class="button-row">
  <button class="button" [disabled] = "!isPinPukChanged()" (click)="stepComplete()">
    {{ 'activation.pin.continue' | translate}}
  </button>
</div>